<div class="modal-header border-b">
  <h4 class="modal-title title">{{modelHeader}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body margin-td">
  <div class="card-content">
    <div class="card-body">
      <div class="row">
        <div class="col-6">
          <div class="af-form-group">
            <label translate>{{'lblDMSName' | translate}} :</label>
            <div class="lbl-info">
              {{dMSQueueLogList.dmsName}}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="af-form-group">
            <label translate>{{'lblActionType' | translate}} :</label>
            <div class="lbl-info">
              {{dMSQueueLogList.actionType}}
            </div>
          </div>
        </div>

        <div class="col-6">
          <div class="af-form-group">
            <label translate>{{'lblModuleName' | translate}} :</label>
            <div class="lbl-info">
              {{dMSQueueLogList.tableName}}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="af-form-group">
            <label>{{'lblReferenceNo' | translate}} :</label>
            <div class="lbl-info">
              {{dMSQueueLogList.no_}}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="af-form-group">
            <label>{{'lblCreatedDate' | translate}} :</label>
            <div class="lbl-info">
              {{dMSQueueLogList.createdDate| date : 'short'}}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="af-form-group">
            <label>{{'lblProcessDate' | translate}} :</label>
            <div class="lbl-info">
              {{dMSQueueLogList.processDate| date : 'short'}}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="af-form-group">
            <label>{{'lblStatus' | translate}} :</label>
            <div class="lbl-info">
              {{dMSQueueLogList.statusText}}
            </div>
            <div class="lbl-info" *ngIf="dMSQueueLogList.statusText == null || dMSQueueLogList.statusText == '' ">
              -
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="af-form-group">
            <label>{{'lblFailedMessage' | translate}} :</label>
            <div class="lbl-info">
              {{dMSQueueLogList.failedMessage}}
            </div>
            <div class="lbl-info" *ngIf="dMSQueueLogList.failedMessage == null">
              -
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">

  <button type="button" class="btn btn-secondary" aria-label="Center Align" (click)="activeModal.dismiss(false)"
    translate>lblClose</button>
</div>